import { COMPARISON_FIELD_OPTIONS, FILTER_COMPONENT_TYPES, LEAD_MARKETPLACE_PRODUCT_LABEL, NEW_STATUS_TYPES, PRODUCT_TYPE_IDS, STATUS_TYPES } from "helpers/sf_constants";

export const PROSPECT_FILTERED_COLUMNS_NAMES = {
    FIRST_NAME: "first_name",
    LAST_NAME: "last_name",
    PHONE_NUM: "phone_num",
    EMAIL: "email",
    STATE: "state",
    CAMPAIGN_NAME: "campaign_name",
    LEAD_TYPE: "lead_type",
    DISPOSITION: "disposition",
    RECEIVED: "received",
    INSURED: 'insured',
    CITY: 'city',
    ADDRESS: 'address',
    ZIP_CODE: 'zip_code',
    VEHICLES: 'vehicles',
    CALL_DURATION: 'call_duration',
    COST: 'cost',
    CALL_STATUS: 'call_status',
    NEW_CALL_STATUS: 'new_call_status',
    TRANSFER_TYPE: 'transfer_type',
    APPLICANTS: 'applicants',
    DRIVERS: 'drivers',
    BRAND_NAME: 'brand_name',
    PRODUCT_TYPE: 'product_type',
    PRODUCT_TYPES: 'product_types',
    DISPOSITIONED: 'is_dispositioned'
}

const PROSPECT_PRODUCT_FILTER_OPTIONS = [
    { label: 'Quote Funnels', value: PRODUCT_TYPE_IDS.QUOTE_FUNNELS },
    { label: LEAD_MARKETPLACE_PRODUCT_LABEL, value: PRODUCT_TYPE_IDS.LEADS }
]

export const buildProductScopedProspectFilters = ({
    filterDefinitions = [],
    currentFilters = [],
    campaigns = [],
    marketplaceFlagEnabled
} = {}) => {
    const selectedProduct = marketplaceFlagEnabled
        ? currentFilters.find(filter => filter.name === PROSPECT_FILTERED_COLUMNS_NAMES.PRODUCT_TYPE && filter.is_active)?.value
        : null
    const productFilter = marketplaceFlagEnabled ? {
        value: selectedProduct,
        label: 'Product',
        name: PROSPECT_FILTERED_COLUMNS_NAMES.PRODUCT_TYPE,
        component_type: FILTER_COMPONENT_TYPES.SINGLE_SELECT,
        options: PROSPECT_PRODUCT_FILTER_OPTIONS,
        is_active: !!selectedProduct
    } : null
    const productTypeIds = selectedProduct
        ? [selectedProduct.value]
        : [PRODUCT_TYPE_IDS.QUOTE_FUNNELS, PRODUCT_TYPE_IDS.LEADS]
    const marketplaceSelected = selectedProduct?.value === PRODUCT_TYPE_IDS.LEADS
    const campaignOptions = campaigns
        .filter(campaign => productTypeIds.includes(Number(campaign.product_type_id)))
        .map(campaign => ({ value: campaign.id, label: campaign.name }))
    const campaignIds = campaignOptions.map(option => option.value)

    const filters = filterDefinitions
        .filter(definition => !marketplaceSelected || ![
            PROSPECT_FILTERED_COLUMNS_NAMES.CALL_STATUS,
            PROSPECT_FILTERED_COLUMNS_NAMES.CALL_DURATION
        ].includes(definition.name))
        .map(definition => {
            const currentFilter = currentFilters.find(filter => filter.name === definition.name)
            const mergedFilter = {
                ...definition,
                ...currentFilter
            }

            if (definition.name !== PROSPECT_FILTERED_COLUMNS_NAMES.CAMPAIGN_NAME) {
                return mergedFilter
            }

            const selectedCampaigns = Array.isArray(currentFilter?.value)
                ? currentFilter.value.filter(option => campaignIds.includes(option.value))
                : []
            const hadSelectedCampaigns = Array.isArray(currentFilter?.value) && currentFilter.value.length > 0

            return {
                ...mergedFilter,
                options: campaignOptions,
                ...(hadSelectedCampaigns ? {
                    value: selectedCampaigns.length ? selectedCampaigns : null,
                    is_active: selectedCampaigns.length > 0
                } : {})
            }
        })

    return productFilter ? [productFilter, ...filters] : filters
}
export const CALL_STATUS_OPTIONS = [
    { value: STATUS_TYPES.BUSY, label: "Busy" },
    { value: STATUS_TYPES.FAILED, label: "Failed" },
    { value: STATUS_TYPES.COMPLETED, label: "Completed" },
    { value: STATUS_TYPES.IN_PROGRESS, label: "In Progress" },
    { value: STATUS_TYPES.NO_ANSWER, label: "No Answer" },
]

export const NEW_CALL_STATUS_OPTIONS = [
    { value: NEW_STATUS_TYPES.BUSY, label: "Busy" },
    { value: NEW_STATUS_TYPES.FAILED, label: "Failed" },
    { value: NEW_STATUS_TYPES.COMPLETED, label: "Completed" },
    { value: NEW_STATUS_TYPES.IN_PROGRESS, label: "In Progress" },
    { value: NEW_STATUS_TYPES.NO_ANSWER, label: "No Answer" },
    { value: NEW_STATUS_TYPES.MULTIPLE_CALLS, label: "Multiple Calls" },
]

export const PROSPECT_FILTERED_COLUMNS_OBJECTS = {
    [PROSPECT_FILTERED_COLUMNS_NAMES.FIRST_NAME]: {
        order: 1,
        comparator_value: "",
        value: "",
        label: "First Name",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.FIRST_NAME, // "first_name",
        component_type: FILTER_COMPONENT_TYPES.TEXT
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.LAST_NAME]: {
        order: 2,
        comparator_value: "",
        value: "",
        label: "Last Name",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.LAST_NAME, // "last_name",
        component_type: FILTER_COMPONENT_TYPES.TEXT
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.PHONE_NUM]: {
        order: 3,
        comparator_value: "",
        value: "",
        label: "Phone",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.PHONE_NUM, // "phone_num",
        component_type: FILTER_COMPONENT_TYPES.TEXT
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.EMAIL]: {
        order: 4,
        comparator_value: "",
        value: "",
        label: "Email",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.EMAIL, // "email",
        component_type: FILTER_COMPONENT_TYPES.TEXT
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.STATE]: {
        order: 5,
        comparator_value: "",
        value: "",
        label: "State",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.STATE, // "state",
        component_type: FILTER_COMPONENT_TYPES.MULTI_SELECT
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.CAMPAIGN_NAME]: {
        order: 6,
        comparator_value: "",
        value: "",
        label: "Campaign Name",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.CAMPAIGN_NAME, // "campaign_name",
        component_type: FILTER_COMPONENT_TYPES.MULTI_SELECT
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.LEAD_TYPE]: {
        order: 7,
        comparator_value: "",
        value: "",
        label: "Lead Type",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.LEAD_TYPE, // "lead_type",
        component_type: FILTER_COMPONENT_TYPES.MULTI_SELECT
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.DISPOSITION]: {
        order: 8,
        comparator_value: "",
        value: "",
        label: "Disposition",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.DISPOSITION, // "disposition",
        component_type: FILTER_COMPONENT_TYPES.MULTI_SELECT
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.RECEIVED]: {
        order: 9,
        comparator_value: "",
        value: "",
        label: "Received",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.RECEIVED, // "received",
        component_type: FILTER_COMPONENT_TYPES.DATE_RANGE
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.INSURED]: {
        order: 10,
        comparator_value: "",
        value: "",
        label: "Insured",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.INSURED, // "Insured",
        component_type: FILTER_COMPONENT_TYPES.SINGLE_SELECT
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.CITY]: {
        order: 11,
        comparator_value: "",
        value: "",
        label: "City",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.CITY, // "City",
        component_type: FILTER_COMPONENT_TYPES.TEXT
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.ADDRESS]: {
        order: 12,
        comparator_value: "",
        value: "",
        label: "Address",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.ADDRESS, // "received",
        component_type: FILTER_COMPONENT_TYPES.TEXT
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.ZIP_CODE]: {
        order: 13,
        comparator_value: "",
        value: "",
        label: "Zip Code",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.ZIP_CODE, // "received",
        component_type: FILTER_COMPONENT_TYPES.TEXT
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.CALL_STATUS]: {
        order: 16,
        comparator_value: "",
        value: "",
        label: "Call Status",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.CALL_STATUS, // "Call Status",
        component_type: FILTER_COMPONENT_TYPES.MULTI_SELECT,
        options: CALL_STATUS_OPTIONS
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.CALL_DURATION]: {
        order: 14,
        comparator_value: "",
        value: COMPARISON_FIELD_OPTIONS[2],
        label: "Call Duration",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.CALL_DURATION, // "Call Duration",
        component_type: FILTER_COMPONENT_TYPES.COMPARATOR,
        options: COMPARISON_FIELD_OPTIONS,
        suffix: " sec"
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.VEHICLES]: {
        order: 19,
        comparator_value: "",
        value: COMPARISON_FIELD_OPTIONS[2],
        label: "Vehicles",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.VEHICLES, // "Vehicles",
        component_type: FILTER_COMPONENT_TYPES.COMPARATOR,
        options: COMPARISON_FIELD_OPTIONS
    },

    [PROSPECT_FILTERED_COLUMNS_NAMES.APPLICANTS]: {
        order: 20,
        comparator_value: "",
        value: COMPARISON_FIELD_OPTIONS[2],
        label: "Applicants",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.APPLICANTS, // "applicants",
        component_type: FILTER_COMPONENT_TYPES.COMPARATOR,
        options: COMPARISON_FIELD_OPTIONS
    }
}

export const PROSPECT_FILTERED_COLUMN_RTB = {
    [PROSPECT_FILTERED_COLUMNS_NAMES.BRAND_NAME]: {
        order: 21,
        comparator_value: "",
        value: "",
        label: "Brands",
        name: PROSPECT_FILTERED_COLUMNS_NAMES.BRAND_NAME, // "brand_name",
        component_type: FILTER_COMPONENT_TYPES.MULTI_SELECT
    }
}
